import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gtd-ui-field-default-comparing-number',
  templateUrl: './comparing-number.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComparingNumberComponent {
  @Input() customClass = '';
  @Input() data: number | string;
  public transformPositive = (value: number | string): number => Math.abs(Number(value)) ?? 0;
}
